import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=d1d8b21a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1d8b21a')) {
      api.createRecord('d1d8b21a', component.options)
    } else {
      api.reload('d1d8b21a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=d1d8b21a&", function () {
      api.rerender('d1d8b21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25UFeUU46JgMz/JS/comp/IncreaseNumber.vue"
export default component.exports